import React from 'react';
import { PlmPartnerDetailForm } from './plmPartner-detail-form';
import { useInjectableComponents } from '../../../system/services/injectableComponentsManager';
import { Box } from '@mui/material';

export const PlmPartnerAdd = () => {
  const { setTitle, setTitlePath } = useInjectableComponents();

  React.useEffect(() => {
    setTitle('Add PLM Partner');
    setTitlePath('/plmPartners');
    return () => {
      setTitle(undefined);
      setTitlePath(undefined);
    };
  }, [setTitle, setTitlePath]);

  return (
    <Box sx={{ p: 2 }}>
      <PlmPartnerDetailForm />
    </Box>
  );
};
